import React from 'react'

const GalleryIcon = props => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="gallery view"
      id="gallery_view"
    >
      <title>Gallery View</title>
      <rect width="4" height="4" fill="white" />
      <rect x="6" width="4" height="4" fill="white" />
      <rect y="6" width="4" height="4" fill="white" />
      <rect x="6" y="6" width="4" height="4" fill="white" />
    </svg>
  )
}

export default GalleryIcon
